import { createContext, useState } from "react";
import { merge } from "lodash";
import { layoutSettings } from "./layouts/settings";

const SettingsContext = createContext({
  updateSettings: () => {},
  settings: layoutSettings,
});

export const SettingsProvider = ({ settings, children }) => {
  const [currentSettings, setCurrentSettings] = useState(settings || layoutSettings);

  const handleUpdateSettings = (update = {}) => {
    const marged = merge({}, currentSettings, update);
    setCurrentSettings(marged);
  };

  return (
    <SettingsContext.Provider
      value={{ settings: currentSettings, updateSettings: handleUpdateSettings }} 
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
